import { queryStringToObject } from './querystring'

const DEFAULT_POPUP_TIMEOUT_MS = 60000
const POLL_INTERVAL_MS = 50
const POPUP_WIDTH = 483
const POPUP_HEIGHT = 600

class AuthPopup {
  popup = null
  create (urlNavigate, popupName, popup) {
    try {
      let popupWindow
      // Popup window passed in, setting url to navigate to
      if (popup) {
        popupWindow = popup
        popupWindow.location.assign(urlNavigate)
      } else if (typeof popup === "undefined") {
        // Popup will be undefined if it was not passed in
        popupWindow = this.openSizedPopup(urlNavigate, popupName)
      }

      // Popup will be null if popups are blocked
      if (!popupWindow) {
        throw new Error('window.open returned null or undefined window object.')
      }
      if (popupWindow.focus) {
        popupWindow.focus()
      }
      this.popup = popupWindow
      window.addEventListener("beforeunload", this.unloadWindow)

      return popupWindow
    } catch (e) {
      console.error(e)
      throw e
    }
  }

  openSizedPopup(urlNavigate, popupName) {
    /**
     * adding winLeft and winTop to account for dual monitor
     * using screenLeft and screenTop for IE8 and earlier
     */
    const winLeft = window.screenLeft ? window.screenLeft : window.screenX;
    const winTop = window.screenTop ? window.screenTop : window.screenY;
    /**
     * window.innerWidth displays browser window"s height and width excluding toolbars
     * using document.documentElement.clientWidth for IE8 and earlier
     */
    const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    const height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    const rand = Math.floor(Math.random() * 20)
    const left = Math.max(0, ((width / 2) - (POPUP_WIDTH / 2)) + winLeft + rand);
    const top = Math.max(0, ((height / 2) - (POPUP_HEIGHT / 2)) + winTop + rand);
    
    return window.open(urlNavigate, popupName, `width=${POPUP_WIDTH}, height=${POPUP_HEIGHT}, top=${top}, left=${left}, scrollbars=yes`);
  }
  
  unloadWindow (e) {
    if (this.popup) {
      this.popup.close()
    }
    // Guarantees browser unload will happen, so no other errors will be thrown.
    e.preventDefault()
  }
  
  destroy (popupWindow) {
    if (popupWindow) {
      // Close window.
      popupWindow.close()
    }
    // Remove window unload function
    window.removeEventListener("beforeunload", this.unloadWindow)
  }
  
  monitorForHash() {
    return new Promise((resolve, reject) => {
      
      const maxTicks = DEFAULT_POPUP_TIMEOUT_MS / POLL_INTERVAL_MS
      let ticks = 0
      
      const intervalId = setInterval(() => {
        if (this.popup.closed) {
          this.destroy()
          clearInterval(intervalId);
          reject()
          return
        }
        
        let href
        try {
          href = this.popup.location.href
        } catch (e) {}

        // Don't process blank pages or cross domain
        if (!href || href === "about:blank") {
          return
        }

        // Only run clock when we are on same domain
        ticks++;
        const contentHash = this.popup.location.hash || this.popup.location.search
        if (contentHash && contentHash.length) {
          const qs = queryStringToObject(contentHash.substring(1))
          this.destroy(this.popup);
          clearInterval(intervalId);
          if(qs.code || qs.access_token) {
            resolve(qs)
          } else {
            reject(qs)
          }          
        } else if (ticks > maxTicks) {
          // Timeout error
          this.destroy(this.popup)
          clearInterval(intervalId)
          reject()
        }
      }, POLL_INTERVAL_MS)
    })
  }  
}
export default AuthPopup
